import React from "react";
import { inject, observer } from "mobx-react";
import { DisputeConstants } from "../DisputeConstants";
import DisputeCommentFormUmpire from "./DisputeCommentFormUmpire";
import Modal from "../../common/modal/Modal";
import DataTable from "../../elements/table/DataTable";
import DateCellFormatter from "../../elements/table/formatters/DateCellFormatter";
import DisputeCommentCellFormatter from "../../elements/table/formatters/DisputeCommentCellFormatter";
import TitleCaseCellFormatter from "../../elements/table/formatters/TitleCaseCellFormatter";
import ZE2LinkCellFormatter from "../../elements/table/formatters/ZE2LinkCellFormatter";
import UmpireCellFormatter from "../../elements/table/formatters/UmpireCellFormatter";

class DisputeResultsUmpire extends React.Component {
  constructor(props) {
    super(props);

    this.commentBubbleClicked = this.commentBubbleClicked.bind(this);
    this.toggleCommentModal = this.toggleCommentModal.bind(this);

    const authStore = props.rootStore.authStore;

    this.columns = [
      {
        name: "Pitch #",
        key: "pitch",
        width: 90,
        formatter: ZE2LinkCellFormatter,
        cellClass: "text-center",
        visible: true,
        sortable: true
      },
      { name: "Game", key: "gameDisplayName", width: 125, visible: true, sortable: true },
      {
        name: "Date *",
        key: "gameDisplayTime",
        width: 150,
        formatter: DateCellFormatter,
        visible: true,
        sortable: true
      },
      {
        name: "Disputed Date",
        key: "disputedDateAsString",
        width: 150,
        formatter: DateCellFormatter,
        visible: true,
        sortable: true
      },
      {
        name: "Umpire",
        key: "umpire",
        width: 200,
        formatter: UmpireCellFormatter,
        visible: authStore.isSuperUmpire,
        sortable: true
      },
      { name: "Reason", key: "disputeReason", visible: true, sortable: true },
      {
        name: "Resolved Date",
        key: "resolvedDateAsString",
        width: 150,
        formatter: DateCellFormatter,
        visible: "resolved"
      },
      {
        name: "Resolution",
        key: "resolution",
        width: 145,
        formatter: TitleCaseCellFormatter,
        visible: "resolved"
      },
      {
        name: "",
        key: "comments",
        width: 55,
        formatter: DisputeCommentCellFormatter,
        cellClass: "editing",
        events: {
          onClick: this.commentBubbleClicked
        },
        visible: true
      }
    ];
  }

  commentBubbleClicked(event, args) {
    const { disputeStore } = this.props.rootStore;
    const dispute = disputeStore.disputeRows[args.rowIdx];
    disputeStore.setSelectedDispute(dispute);
    disputeStore.setCommentModalOpen(!disputeStore.commentModalOpen);
  }

  commentModalClosed() {
    const { disputeStore } = this.props.rootStore;
    disputeStore.setSelectedDispute({});
    disputeStore.setCommentModalOpen(false);
  }

  getColumns() {
    const { disputeStore } = this.props.rootStore;
    const disputeStatusFilter = disputeStore.getFilterValue(DisputeConstants.KEYS.ACTIVE_RESOLVED);
    return this.columns.filter(c => {
      return c.visible === true || c.visible === disputeStatusFilter;
    });
  }

  toggleCommentModal() {
    const { disputeStore } = this.props.rootStore;
    disputeStore.setCommentModalOpen(!disputeStore.commentModalOpen);
  }

  render() {
    const {
      rootStore: { disputeStore }
    } = this.props;
    return (
      <div className="mt-4">
        <Modal show={disputeStore.commentModalOpen} onClose={this.commentModalClosed} size="lg">
          <DisputeCommentFormUmpire toggleModal={this.toggleCommentModal} />
        </Modal>
        <div className="row">
          <DataTable
            data={disputeStore.disputeRows}
            columns={this.getColumns()}
            height={525}
            sortFunc={disputeStore.setSort}
            sortColumn={disputeStore.sort.col}
            sortDirection={disputeStore.sort.asc ? "ASC" : "DESC"}
          />
        </div>
      </div>
    );
  }
}

export default inject("rootStore")(observer(DisputeResultsUmpire));
